module.exports = __webpack_public_path__ + "assets/normal/images/share5.6f9b83fb.png";